import React, { useState, useEffect } from 'react'
import 'css/components/select-box.css'

export const SelectBox = ({
	name,
	options,
	selected = [],
	expand,
	onChange,
}) => {
	const [ keyPrefix, setKeyPrefix ] = useState(
		name.replace(' ', '') + Math.floor(Math.random() * 1000)
	)

	const onCheckboxChange = (target, value) => {
		const newSelected = new Set(selected)

		if (target.checked && newSelected.has(value)) return
		if (!target.checked && !newSelected.has(value)) return

		target.checked
			? newSelected.add(value)
			: newSelected.delete(value)

		onChange(name, [ ...newSelected ])
	}

	return (
		<div name={name} className={`select-box ${expand ? 'expand' : ''}`}>
			<div className="box">
				{selected.length === 0 ? (
					<span className="placeholder">Click Edit to select...</span>
				) : (
					[ ...selected].map((text, i) => (
						<label key={keyPrefix + 'selected' + i}>
							{text}
						</label>
					))
				)}
			</div>
			<div className="options">
				{options.map((text, i) => (
					<span className="option" key={keyPrefix + 'option' + i}>
						<input
							type="checkbox"
							checked={selected.includes(text)}
							onChange={({ target }) => onCheckboxChange(target, text)}
						/>
						<label>{text}</label>
					</span>
				))}
			</div>
		</div>
	)
}
